import { TWidget } from 'widgets/Widget';

type TEvFunction = InstanceType<TWidget>['ev'];

/**
 * @description Base CoreBackToTop implementation.
 * @param BackToTop Base BackToTop for extending
 * @returns Core BackToTop class
 */

function CoreBackToTopClassCreator(BackToTop: import('widgets/global/BackToTop').TBackToTop) {
    /**
     * @category widgets
     * @subcategory global
     * @class CoreBackToTop
     * @augments BackToTop
     * @classdesc Back to top component. Allows scrolling window to top, pressing on a corresponding element.
     * The main functionality based on native anchor links to not only scroll the page but move focus to header.
     * This component only toggle button visibility depending on scroll position.
     * @property {string} data-widget - Widget name `backtotop`
     * @example <caption>Example of BackToTop widget usage</caption>
     * <div
     *     aria-label="${Resource.msg('backtotop.backtotop', 'global', '')}"
     *     data-widget="backtotop"
     *     class="b-back_to_top"
     *     href="${'#'}page-body"
     *     data-tau="back_to_top"
     * >
     *     ... back to top element
     * </div>
     */
    class CoreBackToTop extends BackToTop {
        scrollDisposable?: ReturnType<TEvFunction>;

        prefs() {
            return {
                ...super.prefs()
            };
        }

        init(): void {
            super.init();
        }

        /**
         * @description Initialize widget logic
         */
        doInit(): void {
            this.attachScrollListener();
            this.toggleButtonVisibility();
        }

        /**
         * @description Hide button immediately on click
         */
        onClick(): void {
            this.ref('self').removeClass(this.prefs().activeClassName);
        }
    }

    return CoreBackToTop;
}

export type TCoreBackToTop = ReturnType<typeof CoreBackToTopClassCreator>;

export type TCoreBackToTopInstance = InstanceType<TCoreBackToTop>;

export default CoreBackToTopClassCreator;
